export const isEven = (n) => n % 2 === 0
